import React, { useEffect, useState } from 'react';
import { Table, Input, Tooltip } from 'antd';
import { Button, ColumnProps } from '@digital/ui';
import { useRecoilValue } from 'recoil';
import { dadosGeraisState } from '../atoms';
import { currencyFormat } from '@app/helpers/numbers';
import { formatarDataPadrao } from '@app/helpers/dateTimeFormats';

const { TextArea } = Input;

interface ClausulaAditivo {
    id: number;
    descricao: string;
};

interface Props {
    onChangeClausulas: (clausulas: string[]) => void;
};

const WidgetClausulasAditivo = ({ onChangeClausulas }: Props) => {
    const [clausulas, setClausulas] = useState<ClausulaAditivo[]>([]);
    const dadosGerais = useRecoilValue(dadosGeraisState);

    useEffect(() => {
        const clausulasIniciais: ClausulaAditivo[] = [];

        if (dadosGerais.isValorSemAcrescimoEscopo) {
            const valorAditivo = currencyFormat(dadosGerais.valorAditivoOC) || '';
            const valorAditivoExtenso = dadosGerais.valorAditivoOCExtenso || '';
            const narrativa = dadosGerais.objeto || '';
            clausulasIniciais.push({
                id: 1,
                descricao: `Acrescer ao valor total a quantia de ${valorAditivo} (${valorAditivoExtenso}), referente a ${narrativa}.`
            });
        }

        if (dadosGerais.isPrazo) {
            const dataTerminoAditivo = formatarDataPadrao(dadosGerais.dataFinalWidget) || '';
            clausulasIniciais.push({
                id: 2,
                descricao: `Alterar a data de vencimento para ${dataTerminoAditivo}.`
            });
        }

        const numeroOc = dadosGerais.numero || '';
        clausulasIniciais.push({
            id: 3,
            descricao: `OC: ${numeroOc}.`
        });

        setClausulas(clausulasIniciais);
    }, [dadosGerais]);

    useEffect(() => {
        onChangeClausulas(clausulas.map(c => c.descricao));
    }, [clausulas]);

    const editarClausula = (index: number, descricao: string) => {
        let clausulasTemp = [...clausulas];
        clausulasTemp[index].descricao = descricao;
        setClausulas(clausulasTemp);
    };

    const adicionarClausula = () => {
        const id = clausulas.reduce((prev, curr) => Math.max(curr.id, prev), 0) + 1;
        const novaClausula: ClausulaAditivo = {
            id: id,
            descricao: ''
        };
        setClausulas([...clausulas, novaClausula]);
    };

    const removerClausula = (index: number) => {
        let clausulasTemp = clausulas.filter((_value, idx) => idx !== index);
        setClausulas(clausulasTemp);
    };

    const columns: ColumnProps<ClausulaAditivo>[] = [
        {
            title: 'Cláusulas',
            dataIndex: 'descricao',
            render: (text, _record, index) => {
                return (
                    <TextArea
                        key={`clausula-${index}`}
                        rows={3}
                        defaultValue={text}
                        onBlur={e => editarClausula(index, e.currentTarget.value)}
                    />
                );
            }
        },
        {
            width: '3%',
            className: 'td-centralizado',
            render: (_text, _record, index) => (
                <Tooltip title="Remover">
                    <Button
                        key={`remover-clausula-${index}`}
                        onClick={() => removerClausula(index)}
                        icon="commons-delete"
                    />
                </Tooltip>
            )
        },
    ];

    return (
        <>
            <Table
                key={'widget-clausulas-aditivo'}
                dataSource={clausulas}
                columns={columns}
                pagination={false}
                rowKey={'id'}
            />
            <Button
                title="Nova Cláusula"
                type="link"
                icon="commons-plus"
                onClick={adicionarClausula}
            />
        </>
    );
};

export default WidgetClausulasAditivo;